import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/stores';
import { IUser } from 'src/types/user.type';
import useTenant from '../tenant/tenant.store';
import { setUser } from './user.slice';

export default function useUser() {
  const dispatch = useDispatch();
  const user = useAppSelector((state) => state.user);
  const { changeTenant, changeListTenant } = useTenant();

  const changeUser = (user: IUser | null) => {
    dispatch(setUser(user));
  };

  const clear = () => {
    changeUser(null);
    changeTenant(undefined);
    changeListTenant([]);

    localStorage.removeItem('accesstoken');
    localStorage.removeItem('refreshtoken');
    localStorage.removeItem('expire');
  };

  return {
    user,
    changeUser,
    clear,
  };
}
